import { appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const normaInMetalandQuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow on Immutable Play",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-wishlist-added",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-wishlist",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Download and play Burger IMXpress",
    caption: "Play the game and earn rewards",
    linkUrl: "https://gram.voyage/game/normaland",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "0c941516-d4df-4adf-aa42-fe601ee852cf-download-play-burger-imxpress-clicked",
    ruleId:
      "0c941516-d4df-4adf-aa42-fe601ee852cf-download-play-burger-imxpress",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/norma-in-metaland/NormaInMetalandTrailer.mp4`,
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-trailer-watched",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-trailer",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join GRAM Community on Discord",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/gramecosystem",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-discord-followed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-discord",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow @gram_voyage on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/gram_voyage",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-1-followed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-1",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow @norma_metaland on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/norma_metaland",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-2-followed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-2",
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-onboarding-completed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-onboarding",
  },
];

export const normaInMetalandQuests: QuestGroup[] = [
  {
    key: "level-0",
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    nextQuest: {
      url: "/",
      title: "Next Quest",
      label: "Play Norma In Metaland",
      caption: "Earn +150 Gems",
    },
    totalGemsGranted: 55,
    quests: normaInMetalandQuestsList,
  },
];
